import type { IOption, VerifyVueInstance } from '../type'
import ajax from '@/plugins/ajax/request'
import { URLS } from '@/constant'
import type { GeeTestValidateVo } from '../type'
import '@/utils/gt'
let instance: VerifyVueInstance

class VerifyGeetest {
  isCaptchaInit = false
  isInitCall = false
  captcha = null

  isOnSuccessInit = false

  initCaptcha(params: IOption) {
    const { geetest } = params
    if (this.isCaptchaInit) {
      return Promise.resolve()
    }
    // 防止初始化前被多次调用，默认进入页面打开的会出问题。
    if (this.isInitCall) {
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject({
        type: 'repeat',
        message: 'waiting for getCaptcha'
      })
    }
    return new Promise((resolve, reject) => {
      this.isInitCall = true
      try {
        ;(window as any).initGeetest(
          {
            ...geetest,
            product: 'bind', // 模式
            offline: 0, // 是否是离线模式
            new_captcha: true
          },
          (captchaObj: any) => {
            captchaObj.onReady(() => {
              this.captcha = captchaObj
              this.isCaptchaInit = true
              resolve('initsuccess')
            })
          },
          (err: Error) => {
            this.isInitCall = false
            reject(err)
          }
        )
      } catch (error) {
        console.log(error)
      }
    })
  }

  resetCaptcha() {
    this.isCaptchaInit = false
    this.isOnSuccessInit = false
    this.isInitCall = false
  }

  destroyCaptcha() {
    this.captcha && this.captcha.destroy()
    this.resetCaptcha()
  }

  verifyCaptcha(): Promise<GeeTestValidateVo> {
    return new Promise((resolve, reject) => {
      try {
        !this.isOnSuccessInit &&
          this.captcha.onSuccess(() => {
            // 获取一次验证的凭证
            const validateObj = this.captcha.getValidate()

            resolve({
              challenge: validateObj.geetest_challenge,
              validate: validateObj.geetest_validate,
              seccode: validateObj.geetest_seccode
            })
          })
        this.isOnSuccessInit = true
        this.captcha.verify()
      } catch (error) {
        reject(error)
      }
    })
  }
}
const createInstance = () => {
  const instanceObj: any = new VerifyGeetest()
  instance = instanceObj as VerifyVueInstance
}

const showVerify = async (option: IOption, isRateLimited = false) => {
  if (!instance) {
    createInstance()
  }
  try {
    await instance.initCaptcha(option)
  } catch (error) {
    console.error(error)
    return Promise.reject(error)
  }
  return instance
    .verifyCaptcha()
    .then(async res => {
      const validateUrl = isRateLimited ? URLS.VALIDATE_FOR_RATE_LIMIT : URLS.VALIDATE_CODE
      await ajax.post(validateUrl, { data: { ...option, ...res } })
      instance.destroyCaptcha()
      return Promise.resolve()
    })
    .catch(error => {
      instance.resetCaptcha()
      return Promise.reject(error)
    })
}

const verify = async (option: IOption, isRateLimited = false): Promise<any> => {
  return await showVerify(option, isRateLimited)
}

export default verify
